import { pxToRem, responsiveFontSizes } from "utility/getFontValue";
import i18next from "i18next";
import { checkLanguage } from "utility";

// ----------------------------------------------------------------------

const typography = (language) =>
  ({
    fontFamily: language !== "vi" ? "Prachason" : "Inter",
    fontWeightRegular: 500,
    button: {
      textTransform: "none",
    },
    body1: {
      fontSize: pxToRem(18),
      fontWeight: 500,
      ...responsiveFontSizes({
        sm: 18,
        md: 18,
        lg: 18,
      }),
    },
    body2: {
      fontSize: pxToRem(16),
      fontWeight: 500,
      ...responsiveFontSizes({
        sm: 16,
        md: 16,
        lg: 16,
      }),
    },
    body3: {
      fontSize: pxToRem(14),
      fontWeight: 500,
      ...responsiveFontSizes({
        sm: 14,
        md: 14,
        lg: 14,
      }),
    },
    h4: {
      fontSize: pxToRem(26),
      fontWeight: 600,
      ...responsiveFontSizes({
        sm: 36,
        md: 36,
        lg: 36,
      }),
    },
    h5: {
      fontSize: pxToRem(22),
      fontWeight: 600,
      ...responsiveFontSizes({
        sm: 26,
        md: 26,
        lg: 26,
      }),
    },
    h6: {
      fontSize: pxToRem(22),
      fontWeight: 600,
      ...responsiveFontSizes({
        sm: 22,
        md: 22,
        lg: 22,
      }),
    },
    subtitle1: {
      fontSize: pxToRem(18),
      lineHeight: "1.5",
      fontWeight: 600,
    },
    subtitle2: {
      fontSize: pxToRem(16),
      fontWeight: 600,
      lineHeight: "1.5",
    },
    subtitle3: {
      fontSize: pxToRem(14),
      fontWeight: 600,
      lineHeight: "1.5",
    },
    helper: {
      fontSize: pxToRem(12),
      fontWeight: 500,
      lineHeight: "20px",
      letterSpacing: "0.4px",
    },
  } as const);

export default typography;
